import { CountUp } from 'countup.js';
if (typeof allCounterOptions  !== 'undefined') {
    const allCounters = [];
    for (let [key, value] of Object.entries(allCounterOptions)) {
        let currentOptions = {
            decimalPlaces: value.decimalPlaces,
            prefix: value.prefix,
            suffix: value.suffix,
            enableScrollSpy: true,
            scrollSpyDelay: 500,
            scrollSpyOnce: true
        }
        try {
            allCounters[key] = new CountUp(key, value.countValue, currentOptions);
        } catch (error) {
            console.log("Uncomment line #1 of block020_counting-stats/block.js to import counter.js for counting functionality");
            break;
        } 
    }
}